<template>
  <div class="side-menu scroll-bar">
    <div>
      <tree-menu
        :children="routes"
      ></tree-menu>
    </div>
  </div>
</template>

<script>
import treeMenu from './treeMenu'
export default {
  name: 'SideMenu',

  components: {
    treeMenu
  },

  computed: {
    routes () {
      const routes = /^\/xunjian/.test(this.$route.path) ? this.$store.state.xunjianRoutes : this.$store.state.routes
      return routes || []
    }
  }
}
</script>

<style lang="scss">
  .side-menu {
    padding-left: 15px;
    width: 100%;
    background-color: #fff;
    margin-top: 8px;
  }
</style>
